module.exports = __webpack_public_path__ + "static/media/creator.69e34253.svg";